import './userSettings.scss';
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

import Button from '../../components/Button';
import Translations from '../../requests/apa/Translator';
import Section from './Section';

//IP TELMEX 2
import UtilsIpTelmex from '../../utils/user/IpTelmex';
import { showModal, MODAL_KEYBOARD } from '../../actions/modal';
import { connect } from 'react-redux';
import ActivesSingleton from '../../components/Header/ActivesSingleton';
import Utils  from '../../utils/UserSettings';
import UtilsAPP from '../../utils/Utils';
import { getEnableUpdateEpgButton } from '../../AAFPersistenceManager/helpers/Utils';

import { ALERT_ACTION_IPTELMEX} from '../../containers/App/constants';


class UserSettings extends Component {
  constructor() {
    super();
    this.subscriptionVisibility=Utils.getTabSubscriptionVisibility();
    this.handleBackClick = this.handleBackClick.bind(this);
    this.requireValidateMail = this.requireValidateMail.bind(this);
    this.goValidateMail = this.goValidateMail.bind(this);
    this.showRemoteControl=false;
  }

  componentWillMount(){
    this.showRemoteControl=UtilsAPP.getRegionaliazedMetadata('rc_default_config',{config:'full',enable:false}).enable;
    //this.showRemoteControl=true;
  }
  componentDidMount() {
    window.SpatialNavigation.focus('#language-button');
    const section = document.getElementById(this.props.match.params.section);

    if (section) {
      section.className = 'selected';
    }

  }
  componentDidUpdate() {
    //TODO de verdad esto es la mejor forma de hacerlo?
    let selected=document.getElementsByClassName('selected');
    selected=[...selected];
    selected.map(x=>x.className='');
    const section = document.getElementById(this.props.match.params.section);
    if (section) {
      section.className = 'selected';
    }


  }

  handleBackClick() {
    const history = this.props.history;
    history.goBack();
  }

  getBtnBack() {
    const backText = Translations.get("btn_menu_back", "Volver");

    const btnBack = (
      <div className={`resume-back`}>
        <Button
          text={ backText }
          iconClassName="fa fa-undo back"
          onClick={ this.handleBackClick }
        />
      </div>
    );

    return  this.props.showBack ? btnBack : null;
  }

  requireValidateMail() {
    const that = this;

    UtilsIpTelmex.validateMail(that.props.user.session_userhash).then(function (resp) {
      if (!resp.validEmail) {
        //that.goValidateMail(null, that.props.user.session_userhash, resp);
        const detail = {
          isAlertVisible : true, 
          alertAction: ALERT_ACTION_IPTELMEX};
  
        document.dispatchEvent(
          new CustomEvent(settings.show_head_band, { detail })
        );
      }
    });
  }

  goValidateMail = (callback, userhash, resp) => {
    console.log('===> goValidateMail');

    const modalProps = {
      onOmit: callback,
      userhash: userhash,
      phone: resp.userDetectWS && resp.userDetectWS.account ? resp.userDetectWS.account : '',
    };

    const modal = {
      modalType: MODAL_KEYBOARD,
      modalProps: {
        ...modalProps,
      }
    };
    this.props.showModal(modal);
  };

  handleMouseEnter = (event) =>{    
    const x = document.getElementById(event);
    window.SpatialNavigation.focus(x);
 }

  render() {
    const tabIdioma=<li id='idioma'><Link id='idioma-link' onMouseEnter={() => this.handleMouseEnter('idioma-link')} to="/user-settings/idioma" className="focusable">{Translations.get("language_title", "Idioma")}</Link></li>;
    const tabControlParental=<li id="parental_control"><Link id='parental_control-link' onMouseEnter={() => this.handleMouseEnter('parental_control-link')} to="/user-settings/parental_control" className="focusable">{Translations.get("parental_title", "Control parental")}</Link></li>;
    const tabRecordatorios=<li id='recordatorios'><Link id='recordatorios-link' onMouseEnter={() => this.handleMouseEnter('recordatorios-link')} to="/user-settings/recordatorios" className="focusable">{Translations.get("reminders_title", "Recordatorios")}</Link></li>;
    const tabSubscriptions=<li id='subscriptions'><Link to="/user-settings/subscriptions" className="focusable">{Translations.get("subscriptions_title", "Suscripciones")}</Link></li>;
    const tabUpdateEpg=<li id='update_epg'><Link to="/user-settings/update_epg" className="focusable">{Translations.get("update_epg_title", "EPG")}</Link></li>;
    const tabRemoteControl=this.showRemoteControl && <li id='remote_control'><Link to="/user-settings/remote_control" className="focusable">{Translations.get("remote_title", "Control Remoto")}</Link></li>;
    let optionaTitle = [{
      id: 'remote_control',
      title: Translations.get("remote_title", "Control Remoto")
    }];

    switch (this.props.match.params.section)
    {
      case 'subscriptions':
        optionaTitle =Translations.get("subscriptions_title", "Suscripciones");
        break;
      case 'update_epg':
        optionaTitle =Translations.get("subscriptions_title", "Actualización de la guía de programación");
        break;
      default:
        break;

    }
    return(
      <div id="user-settings">
        { this.getBtnBack() }
        <ul id="SettingsMenu">
          {tabIdioma}
          {new ActivesSingleton().nodeTvExits() ? tabRecordatorios : null}
          {tabControlParental}
          {this.subscriptionVisibility.enable?tabSubscriptions:null}
          {tabRemoteControl}
          {getEnableUpdateEpgButton().enable && tabUpdateEpg}
        </ul>
        <Section section={ this.props.match.params.section } subsection={ this.props.match.params.subsection} optionaTitle={optionaTitle} />
      </div>
    );
  }
}
const mapStateToProps = (state) => { return { user: state.user } };
export default connect(mapStateToProps, { showModal})( withRouter(UserSettings));



// WEBPACK FOOTER //
// ./src/containers/User-Settings/index.jsx